import __request__ from "routing/request";
export function get(streamid, requestOptions) {
  return __request__("GET", `/streams/${streamid}/outputs`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function add(streamid, JSONbody, requestOptions) {
  return __request__("POST", `/streams/${streamid}/outputs`, JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function remove(streamid, outputId, requestOptions) {
  return __request__("DELETE", `/streams/${streamid}/outputs/${outputId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getBystreamidAndoutputId(streamid, outputId, requestOptions) {
  return __request__("GET", `/streams/${streamid}/outputs/${outputId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
